import { marked } from 'marked'

import content from '@/docs/Changelog.md?raw'

export default {
  updated: new Date('2025-04-10T13:05:00.000Z').toISOString(), // UTC (+0)
  content: {
    html: marked.parse(content),
    raw: content,
  },
}
